import React, { useEffect, useState } from "react";
import api from "../lib/api";
import ProductCard from "../components/ProductCard";

const CATEGORIES = [
  { value: "all", label: "All" },
  { value: "saffron", label: "Saffron" },
  { value: "honey", label: "Honey" },
  { value: "spices", label: "Spices" },
];

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [cat, setCat] = useState("all");

  useEffect(() => {
    const params = cat === "all" ? {} : { category: cat };
    api.get("/products", { params }).then((r) => setProducts(r.data));
  }, [cat]);

  return (
    <div data-testid="shop-page" className="pt-32 pb-24 max-w-7xl mx-auto px-6 md:px-12">
      <p className="text-xs uppercase tracking-overline text-[#4A5D23] mb-4">The Cellar</p>
      <h1 className="font-serif-display text-6xl md:text-8xl tracking-tighter leading-none mb-12">
        Shop <em className="text-[#C84B31] not-italic">all lots</em>
      </h1>

      <div data-testid="category-filters" className="flex flex-wrap gap-3 mb-16 border-b border-[#D5D1C5] pb-6">
        {CATEGORIES.map((c) => (
          <button
            key={c.value}
            data-testid={`filter-${c.value}`}
            onClick={() => setCat(c.value)}
            className={`px-5 py-2 text-xs uppercase tracking-overline border transition-colors ${
              cat === c.value
                ? "bg-[#1A1A1A] text-[#FAF9F6] border-[#1A1A1A]"
                : "bg-transparent text-[#1A1A1A] border-[#D5D1C5] hover:border-[#1A1A1A]"
            }`}
          >
            {c.label}
          </button>
        ))}
      </div>

      {products.length === 0 ? (
        <p data-testid="no-products" className="text-[#7A7A7A] py-20 text-center">No products in this category yet.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
